import { cardRef, defineGameCard, onAppear } from '../authoring/index.js';
export const BannerCaptainCard = defineGameCard({
    id: 'banner_captain',
    gameplay: { type: 'UNIT', cost: 5, baseStats: { attack: 4, health: 6 } },
    presentation: {
        name: 'Капитан со знаменем',
        description: 'При раскрытии остальные ваши бойцы получают +1 к атаке до конца раунда.',
        glyph: {
            colors: ['#10213A', '#C85F3A', '#28476C', '#F3AE66', '#E79A33'],
            rows: [
                '....................',
                '....................',
                '.............122....',
                '.....11111...12222..',
                '.....133331..1242222',
                '.....155551..1242242',
                '....1212221..124424.',
                '.....124441..122422.',
                '.....124441..122222.',
                '...1111111...12..222',
                '..1551133115.1....22',
                '..1133333531.1......',
                '..1333333531.1......',
                '..1333333531141.....',
                '..1333333531141.....',
                '..1331333531121.....',
                '..1331133531.1......',
                '..1331111111.1......',
                '..1331333531.1......',
                '..1331333531.1......',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('banner_captain')],
    abilities: [onAppear((ctx) => {
            if (ctx.self === undefined)
                return;
            for (const unit of ctx.q.unitsOf(ctx.self.controllerId)) {
                if (unit.id === ctx.self.id || ctx.q.cardType(unit.id) !== 'UNIT')
                    continue;
                ctx.ops.addEffect({
                    defId: BannerCaptainCard.id,
                    scope: { kind: 'unit', instanceId: unit.id },
                    sourceId: ctx.self.id,
                    duration: 1,
                    persistent: true,
                    statMods: [{ stat: 'attack', op: 'add', value: 1 }],
                });
            }
        }, { cause: 'played' })],
});
//# sourceMappingURL=banner_captain.js.map